<p-button
  [label]="loading ? '' : label"
  [disabled]="isDisabled"
  [ngClass]="getButtonClasses()"
  [type]="type"
  [routerLink]="routerLink"
  [style.--button-custom-color]="color"
  class="custom-button"
  [ariaLabel]="accessibleName ?? undefined"
  [attr.title]="isIconOnly ? accessibleName : null"
  (click)="handleClick($event)">
  <ng-container *ngIf="loading">
    <span class="custom-spinner" aria-hidden="true"></span>
  </ng-container>
  <ng-container *ngIf="!loading && icon">
    <lucide-icon [name]="icon" class="custom-icon"></lucide-icon>
  </ng-container>
</p-button>